import { AttributeValue } from "../../dom-tools/AttributeValue";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { Insight } from "../../dom-tools/Insight";
import { LCG, LCGState } from "../../random/LCG";
import { OpacityFadingTextFX } from "./modules/OpacityFadingTextFX";
import { TextFXElement } from "./TextFXElement";
import { TextFXLetter } from "./TextFXLetter";
import { TextFXModule, TextFXModuleSettings } from "./TextFXModule";
import { TextFXModulesLibrary } from "./TextFXModulesLibrary";

export class TextFX
{
  static readonly type   = new ElementType( "text--fx" );
  static readonly content  = new ElementType( "text--fx-content" );
  static readonly event  = new ElementType( "text--fx-event" );
  static readonly eventType  = new ElementAttribute( "type" );
  static readonly space = new ClassFlag( "space" );
  
  static readonly onInsight   = new AttributeValue( TextFX.eventType, "on-insight" );
  static readonly onOffsight  = new AttributeValue( TextFX.eventType, "on-offsight" );

  static readonly letter = new ElementType( "text--fx-letter");
  static readonly random = new LCG();
  static #seed:LCGState;
  static insight:Insight;

  static readonly modules = TextFXModulesLibrary.modules;

  static applyOnDocument( insight:Insight )
  {
    TextFX.insight = insight;

    if ( ! TextFX.#seed )
    {
      TextFX.random.warmUp();
      TextFX.#seed = TextFX.random.getSeedState() as LCGState;
    }

    TextFX.random.setSeedState( TextFX.#seed );

    TextFX.type.forAllInDoc( e => this.applyOnElement( e ) ); 
  }

  static applyOnElement( element:Element )
  {    

    let text = TextFX.content.query( element ).textContent.trim();
    let allEventsContainer = TextFX.event.queryAll( element );

    element.innerHTML = "";

    let fx = new TextFXElement();
    fx.element = element;

    for ( let i =0 ; i < text.length; i++ )
    {
      if ( text[ i ] == "°" )
      {
        element.appendChild( ElementType.break.create() );
        continue;
      }

      let letter = new TextFXLetter();
      letter.element = TextFX.letter.create( text[ i ] );
      
      if ( /^\s+$/.test( text[ i ] ) )
      {
        TextFX.space.set( letter.element );
      }

      letter.index = i;
      letter.numLetters = text.length;

      
      fx.letters.push( letter );
      element.appendChild( letter.element );
    }

    
    for ( let e = 0; e < allEventsContainer.length; e++ )
    {
      let eventContainer = allEventsContainer[ e ];
      let list:TextFXModuleSettings[] = [];
      let eventName = TextFX.eventType.from( eventContainer );

      if ( ! fx.initialEvent )
      {
        fx.initialEvent = eventName;
      }

      for ( let i = 0; i < eventContainer.childNodes.length; i++ )
      {
        let child = eventContainer.childNodes[ i ] as Element;
        let module = TextFX.modules.find( m => m.type.is( child ) );

        if ( ! module )
        {
          continue;
        }

        let settings = module.getSettings( child );
        list.push( settings );
      }

      fx.events.set( eventName, list );

      if ( TextFX.onInsight.in( eventContainer )  )
      {
        TextFX.insight.onInsight( fx.element, ()=>{ fx.dispatch( eventName ) } );
      }

      if ( TextFX.onOffsight.in( eventContainer ) )
      {
        TextFX.insight.onOffsight( fx.element, ()=>{ fx.dispatch( eventName ) } );
      }
      
    }

    fx.dispatch( fx.initialEvent );
  }
}